module.exports = __webpack_public_path__ + "img/smart-meter-logo.8e32e4f7.png";